/**
 * TypingIndicator component.
 *
 * Animated three-dot indicator shown while the bot is processing.
 * Dots use a staggered bounce animation via CSS keyframes.
 * The component can be shown/hidden via method calls.
 */

export class TypingIndicator {
  private readonly element: HTMLElement;
  private visible = false;

  constructor() {
    this.element = document.createElement("div");
    this.element.className = "hana-typing";
    this.element.setAttribute("role", "status");
    this.element.setAttribute("aria-label", "Bot is typing");
    // Start hidden
    this.element.classList.add("hana-typing--hidden");

    const dotsContainer = document.createElement("div");
    dotsContainer.className = "hana-typing__dots";

    for (let i = 0; i < 3; i++) {
      const dot = document.createElement("span");
      dot.className = "hana-typing__dot";
      dot.style.animationDelay = `${i * 0.15}s`;
      dotsContainer.appendChild(dot);
    }

    this.element.appendChild(dotsContainer);
  }

  getElement(): HTMLElement {
    return this.element;
  }

  show(): void {
    if (this.visible) return;
    this.visible = true;
    this.element.classList.remove("hana-typing--hidden");
  }

  hide(): void {
    if (!this.visible) return;
    this.visible = false;
    this.element.classList.add("hana-typing--hidden");
  }

  isVisible(): boolean {
    return this.visible;
  }
}
